"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight_1 = __importDefault(require("../constants/gameHeight"));
const gameWidth_1 = __importDefault(require("../constants/gameWidth"));
const unitsPerTile_1 = __importDefault(require("../constants/unitsPerTile"));
const state_1 = __importDefault(require("../state"));
const getTilemap_1 = __importDefault(require("./definables/getTilemap"));
const getCameraScreenCoords = () => ({
    x: Math.floor((gameWidth_1.default / 2)
        - (((state_1.default.cootsCoords.x / unitsPerTile_1.default) * ((0, getTilemap_1.default)(state_1.default.level.tilemapSlug).tileWidth / 2))
            - ((state_1.default.cootsCoords.y / unitsPerTile_1.default) * ((0, getTilemap_1.default)(state_1.default.level.tilemapSlug).tileWidth / 2))
            - 1)),
    y: Math.floor((gameHeight_1.default / 2)
        - (((state_1.default.cootsCoords.x / unitsPerTile_1.default) * ((0, getTilemap_1.default)(state_1.default.level.tilemapSlug).tileHeight / 2))
            + ((state_1.default.cootsCoords.y / unitsPerTile_1.default) * ((0, getTilemap_1.default)(state_1.default.level.tilemapSlug).tileHeight / 2))
            - 6))
});
exports.default = getCameraScreenCoords;
